import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiActivity, FiFilePlus, FiCheckCircle, FiMessageSquare, FiTrendingUp} = FiIcons;

function getActivityIcon(text = '') {
  const lower = text.toLowerCase();
  if (lower.includes('plan') || lower.includes('create')) return FiFilePlus;
  if (lower.includes('task') || lower.includes('done') || lower.includes('approv')) return FiCheckCircle;
  if (lower.includes('chat') || lower.includes('lead') || lower.includes('consult')) return FiMessageSquare;
  if (lower.includes('revenue') || lower.includes('finance') || lower.includes('ao')) return FiTrendingUp;
  return FiActivity;
}

export default function HqActivityFeed({activity = []}) {
  return (
    <section className="panel hq-activity-panel">
      <div className="section-heading">
        <div>
          <span className="eyebrow">Audit log</span>
          <h3>Recent activity</h3>
        </div>
      </div>

      <div className="hq-activity-list">
        {activity.length === 0 ? (
          <p className="muted">No activity logged yet.</p>
        ) : (
          activity.slice(0, 7).map((item) => {
            const Icon = getActivityIcon(item.text);
            return (
              <div key={item.id} className="hq-activity-row">
                <span className="activity-icon-badge">
                  <SafeIcon icon={Icon} />
                </span>
                <div className="activity-text">
                  <p>{item.text}</p>
                  <small>{item.time || 'Recently'}</small>
                </div>
              </div>
            );
          })
        )}
      </div>
    </section>
  );
}
